module.exports = __webpack_public_path__ + "media/images/icons/country_flags/se-8b8db9f4172ba5d8d3c43f104a9a0339.svg";